<template>
  <section class="all-commends" ref="allCommends">
    <div class="commend" v-for="(item, index) in comments" :key="index">
      <div class="title">
        <p>
          <img :src="item.avatar_url | transHTTP" alt="">
          <span class="name">{{item.nickname | hideName}}</span>
        </p>
        <p class="stars" color-primary>
          <i class="iconfont etc-icon-star" v-for="(i, index) in getArr(item.stars)" :key="index"></i>
        </p>
      </div>
      <div class="content">{{item.content}}</div>
      <div class="photos" v-if="item.imgs">
        <img v-for="(i, imgIndex) in item.imgs" :src="i | transHTTP" :class="{'large': item.imgs.length===1}" :key="imgIndex" alt="">
      </div>
      <p class="card-type">{{item.card_type===1?'记账卡':'储值卡'}}</p>
    </div>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// api
import NewApplyApi from '@/api/newApply.api'

let customData = {
  page: 1,
  loading: false
}

export default {
  name: 'allCommends',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      comments: []
    }
  },
  computed: {},
  methods: {
    // 获取某长度数组
    getArr(len) {
      return new Array(Number(len)).fill('0')
    },
    async getList() {
      if (customData.page < 0) {
        this.m_showToast({class: 'no-mask', msg: '没有更多数据', timeout: 1000})
        return
      }
      try {
        !customData.page && this.m_showLoading()
        customData.loading = true
        const {comments} = await NewApplyApi.getCommentList({page: customData.page})
        if (comments) {
          this.comments = [...this.comments, ...comments]
          customData.page++
        } else {
          customData.page = -1
          this.m_showToast({class: 'no-mask', msg: '没有更多数据', timeout: 1000})
        }
      } finally {
        customData.loading = false
        customData.page && this.m_loadingClose()
      }
    }
  },
  async mounted() {
    window.onscroll = () => {
      if (customData.loading) return
      let wH = window.innerHeight
      let allH = this.$refs.allCommends.offsetHeight
      let scrollT = window.scrollY
      let h = allH - wH - scrollT
      if (h < 10) {
        this.getList()
      }
      // console.log('onscroll', document.body.scrollTop, window.scrollY, wH, allH, allH - wH)
    }
    customData.page = 0
    this.getList()
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.all-commends{
  padding-left: 40px;
  .commend{
    border-top: 1px solid #dddddd;
    padding-right: 40px;
    .title{
      padding: 20px 0;
      @extend %flex-space-between;
      p:first-child{
        @extend %flex-center;
        img{
          width: 52px;
          height: 52px;
          border-radius: 50%;
        }
        .name{
          color: #333333;
          font-size: 26px;
          margin-left: 20px;
        }
      }
      .stars{
        i{
          font-size: 18px;
          margin-left: 5px;
        }
      }
    }
    .content{
      font-size: 26px;
      color: #666666;
      height: 74px;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 20px;
    }
    .photos{
      position: relative;
      @extend %flex-start-wrap;
      img{
        width: 216px;
        height: 216px;
        margin-right: 12px;
        &.large{
          width: 350px;
          height: 350px;
        }
      }
    }
    .card-type{
      font-size: 20px;
      color: #999999;
      padding: 10px 0 20px;
    }
    &:first-child{
      border-top: none;
    }
  }
}
</style>
